import React from 'react'

import { capitalizeString } from '../../../../utilities/helpers'

import Stack from 'react-bootstrap/Stack'
import Badge from 'react-bootstrap/Badge'

import { EditDeleteDropdown } from '../../../EditDeleteDropdown'

export default function Member({
  canManageTeam,
  member,
  handleResend,
  handleShowAdd,
  handleShowDelete,
  nameMatchesReservedAccountOwner,
}) {
  const memberHeadingId = `team-member-heading-${member?.uuid ?? 'unknown'}`

  return (
    <Stack
      direction="horizontal"
      as="li"
      className="list-item split-row"
      aria-labelledby={memberHeadingId}
    >
      <h2 id={memberHeadingId} className="heading heading-sm lh-lg m-0">
        {capitalizeString(`${member?.firstName} ${member?.lastName}`)}
      </h2>
      <Stack direction="horizontal" gap={2}>
        <Badge
          bg={`${member?.role?.name === 'Account Owner' ? 'success' : 'default'}`}
          className={`text-uppercase ${member?.role?.name !== 'Account Owner' ? 'badge-outline badge-outline--dark' : ''}`}
        >
          {capitalizeString(member?.role?.name)}
        </Badge>
        {/* account owners and admins can edit/delete team members */}
        {canManageTeam && (
          <>
            {/* member role is not account owner or is pending, show dropdown menu */}
            {(!nameMatchesReservedAccountOwner(member?.role?.name) ||
              member?.pending) && (
              <EditDeleteDropdown
                pending={member?.pending}
                handleResend={() => handleResend(member)}
                onClick={(e) => handleShowAdd(e, member)}
                handleShow={() => handleShowDelete(member)}
                moreActionsToggleTestId={`team-member-more-${member.uuid}`}
                editMenuItemTestId={`team-member-edit-${member.uuid}`}
                resendInvitationItemTestId={`team-member-resend-${member.uuid}`}
              />
            )}
          </>
        )}
      </Stack>
    </Stack>
  )
}
